import { render, staticRenderFns } from "./saveBtn.vue?vue&type=template&id=15c40eab&scoped=true&"
import script from "./saveBtn.vue?vue&type=script&lang=js&"
export * from "./saveBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c40eab",
  null
  
)

export default component.exports